/**
 * networkStatus.ts — Estado de conectividad del dispositivo (sin depender de axios).
 *
 * QUÉ HACE: Lee online/offline vía navigator + Capacitor Network en APK.
 * QUÉ EXPORTA: isDeviceOnline, shouldPreferLocalCajaOps, refreshDeviceOnlineStatus
 * QUÉ NO DEBE HACER: Mostrar UI ni toasts.
 */

import { isCajaRemoteApiEnabled } from "@/features/caja/utils/cajaSessionLocal";

let cachedOnline =
  typeof navigator !== "undefined" ? navigator.onLine !== false : true;

/** Último valor conocido de conectividad a internet del dispositivo. */
export function isDeviceOnline(): boolean {
  return cachedOnline;
}

export function setDeviceOnlineSnapshot(online: boolean): void {
  cachedOnline = online;
}

/** Demo/local: operaciones de caja van directo a LS sin esperar API. */
export function shouldPreferLocalCajaOps(): boolean {
  return !isDeviceOnline() && !isCajaRemoteApiEnabled();
}

/** Relee estado (navigator + Capacitor Network si está disponible). */
export async function refreshDeviceOnlineStatus(): Promise<boolean> {
  let online =
    typeof navigator !== "undefined" ? navigator.onLine !== false : true;

  try {
    const cap = (
      window as unknown as { Capacitor?: { getPlatform?: () => string } }
    ).Capacitor;
    if (cap?.getPlatform?.() !== "web") {
      const { Network } = await import("@capacitor/network");
      const status = await Network.getStatus();
      online = status.connected;
    }
  } catch {
    /* navigator.onLine */
  }

  cachedOnline = online;
  return online;
}
